import { render } from "./HomeContact.vue?vue&type=template&id=fe67d3b4&scoped=true"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import "./HomeContact.vue?vue&type=style&index=0&id=fe67d3b4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe67d3b4"]])

export default __exports__